import React from "react";
import { Box, Grid, Typography } from "@material-ui/core";

import HistoryAndForecastRevenueGrowthByStore from "./HistoryAndForecastRevenueGrowthByStore";
import RankedGrowthClassification from "./RankedGrowthClassification";
import RankedForecastGrowthClassification from "./RankedForecastGrowthClassification";

const RankedRevenueGrowth = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Box paddingBottom={3}>
                    <Typography variant="h6" component="div" gutterBottom>
                        History and forecast revenue growth by store
                    </Typography>
                </Box>
                <Box display="flex" flexDirection="column" >
                    <Box flexGrow={1} width='100%' height={'55vh'} data-cy="ranked-revenue-data-grid" >
                        <HistoryAndForecastRevenueGrowthByStore />
                    </Box>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <RankedGrowthClassification />
            </Grid>
            <Grid item xs={12}>
                <RankedForecastGrowthClassification />
            </Grid>
        </Grid>
    );
};

export default RankedRevenueGrowth;
